
import { RootState } from './store';

export const loggedInDetails = (state: RootState) => state.loggedInDetails;
export const selectedMenu = (state: RootState) => state.selectedMenu;
export const datalayers = (state: RootState) => state.datalayers;